module.exports = __webpack_public_path__ + "static/media/logo_collapsed.8f435c9c.png";